<template>
  <section-page
    title="KPIs"
    full-height
  >
    <template v-slot:right>
      <table-buttons
        show-refresh
        show-filters-button
        :do-refresh="reloadStats"
        :do-filters-apply="applyFilters"
        :do-filters-reset="resetFilters"
      >
        <template v-slot:columns></template>

        <template v-slot:filters>
          <stats-kpi-filter
            ref="filters"
            :has-user-filter="activeTab === 'Appointments'"
          />
        </template>
      </table-buttons>
    </template>

    <b-tabs v-model="activeTab" type="is-boxed">
      <template v-for="tab in tabs">
        <b-tab-item
          :key="tab.id"
          :value="tab.id"
          :label="tab.id"
        >

        </b-tab-item>
      </template>
    </b-tabs>

    <div class="kpi_table--overview">
      <div class="kpi_table fixed">
        <stats-kpi-column-label/>
        <stats-kpi-column-goal/>
        <stats-kpi-column-average/>
        <stats-kpi-column-today ref="todayColumn"/>
      </div>

      <div class="kpi_table scrollable">
        <!-- Other Data Columns -->
        <stats-kpi-column-data
          ref="columns"
          v-for="(column, index) in columnData"
          :key="index"
          :column-data="column"
        />
      </div>
    </div>
  </section-page>
</template>

<script>
import StatsKpiFilter from './components/StatsKpiFilter';
import AppInfoTip from "../../components/app/AppInfoTip";
import StatsKpiColumnLabel from "./components/StatsKpiColumnLabel";
import StatsKpiColumnData from "./components/StatsKpiColumnData";
import StatsKpiColumnGoal from "./components/StatsKpiColumnGoal";
import StatsKpiColumnAverage from "./components/StatsKpiColumnAverage";
import StatsKpiColumnToday from "./components/StatsKpiColumnToday";
import TableButtons from "../../components/table/TableButtons.vue";
import CancelablePromise from "../../services/CancelablePromise";

export default {
  components: {
    TableButtons,
    StatsKpiColumnAverage,
    StatsKpiColumnGoal,
    StatsKpiColumnData,
    StatsKpiColumnLabel,
    StatsKpiColumnToday,
    AppInfoTip,
    StatsKpiFilter
  },
  data() {
    return {
      reloadingStatsPromise: null,
      activeTab: 'Comms',
      tabs: [
        {id: 'Comms'},
        {id: 'Leads'},
        {id: 'Appointments'},
        {id: 'Wholesale'},
        {id: 'FlipAndFix'},
      ],
    }
  },
  watch: {
    'activeTab' (newValue) {
      this.$store.commit('statsKpi/setActiveTab', newValue)
      this.reloadStats();
    }
  },
  mounted() {
    this.$store.commit('statsKpi/setActiveTab', 'Comms')
    this.$store.dispatch("statsKpi/setup");
    this.reloadStats();
  },
  computed: {
    columnData() {
      return this.$store.getters["statsKpi/columnData"]
    },
  },
  methods: {
    resetFilters() {
      this.$refs.filters.resetFilters();
    },
    applyFilters() {
      this.$refs.filters.applyFilters();
      this.reloadStats();
    },
    async reloadStats() {
      if (this.reloadingStatsPromise) {
        this.reloadingStatsPromise.cancel();
      }

      this.reloadingStatsPromise = CancelablePromise(new Promise(async (resolve) => {
        this.$store.commit("statsKpi/resetKpiRowInfoAmount")
        await this.$refs.todayColumn.getColumnAmounts();

        for(let i=0; i <  this.$refs.columns.length; i++) {
          await this.$refs.columns[i].getColumnAmounts();
        }

        resolve();
      }))
    }
  },
}
</script>

<style lang="scss">
@import "../../styles/variables/variables";

.kpi_table--overview {
  position: relative;
  display: flex;
}

.kpi_table {
  display: flex;

  &.fixed {
    flex: 0 0 calc($kpiColumnLabel + ($kpiColumnSkinny * 3))
  }

  &.scrollable {
    flex-grow: 1;
    overflow-x: auto;
  }

  &--column {

    &--heading,
    &--cell {
      padding-left: 10px;
      padding-right: 10px;
    }

    &--heading {
      min-height: 29px; // line height plus border
      border-bottom: 1px solid $borderDark;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
      line-height: 28px;
    }

    &--cell {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid $borderDark;
      border-right: 1px solid $borderDark;
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
